import script from "./AddSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSaleCategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSaleCategoryModal.vue?vue&type=style&index=0&id=08783998&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08783998"]])

export default __exports__